import React from 'react'
import { Modal } from 'react-bootstrap'
import { MdClose } from 'react-icons/md'
import ButtonCustom from '../../../../components/IES2/ButtonCustom'
import { useIntl } from 'react-intl'

export default function ConfirmCloseClassroomModal ({ setConfirmModal, cancelModal, confirmModal, handleExit, handleClose }) {
  const intl = useIntl()
  return (
    <Modal centered backdrop="static" show={confirmModal} onHide={() => cancelModal()}>
      <Modal.Header className="border-0 pb-0" closeButton />
      <Modal.Body>
        <div className="d-flex flex-column justify-content-center align-items-center mb-3">
          <MdClose className="--d-icon-xxxl --d-fw-700 --d-color-primary mb-2"/>
          <p className="--d-fw-600 --d-text-lg --d-color-secundary text-center mb-0">{intl.formatMessage({ id: 'closeSchedulingModal.title', defaultMessage: 'Tem certeza que deseja sair?' })}</p>
        </div>

        <div className="d-flex flex-column justify-content-center align-items-center border-0">
          <ButtonCustom format="d-flex justify-content-center align-items-center --btn-primary w-50 mb-3" onClick={() => handleExit(1)}>{intl.formatMessage({ id: 'confirmCloseClassroomModal.exit', defaultMessage: 'Sair' })}</ButtonCustom>
          <ButtonCustom format="d-flex justify-content-center align-items-center --btn-white w-50 mb-1" onClick={() => cancelModal()}>{intl.formatMessage({ id: 'closeSchedulingModal.cancel', defaultMessage: 'Cancelar' })}</ButtonCustom>
          {/* <ButtonCustom format="d-flex justify-content-center align-items-center mb-2 --btn-white w-50" onClick={() => { */}
          {/*  handleClose() */}
          {/*  setLoading() */}
          {/* }}>Encerrar Sala</ButtonCustom> */}
          {/* <p className="--d-fw-400 --d-text-lg w-75 w-md-50 --d-color-secundary  text-center mb-3">Todos os participantes serão expulsos desta sala</p> */}
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0"/>
    </Modal>
  )
}
